import {
  CANCEL,
  DONE,
  FETCH_SECTION_AVAILABILITY_FULFILLED,
  FETCH_SECTION_AVAILABILITY_PENDING,
  FETCH_SECTION_AVAILABILITY_REJECTED,
  FETCH_SECTION_AVAILABILITY_ABORT,
} from '../constants';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';


export const defaultState = {
  fetched: false,
  fetching: false,
  data: [],
};

export default function sectionAvailabilityReduce(state = defaultState, action) {
  switch (action.type) {
    case DONE:
    case CANCEL:
      return {
        ...defaultState,
      };

    case FETCH_SECTION_AVAILABILITY_PENDING:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_SECTION_AVAILABILITY_FULFILLED: {
      const sectionAvailabilityData = get(action, 'payload.body.SectionAvailabilityData', []);

      /* Empty returned section availability data does not set the state to an empty array */
      if (isEmpty(sectionAvailabilityData)) {
        return {
          ...state,
          fetched: true,
          fetching: false,
        };
      }

      return {
        ...state,
        data: sectionAvailabilityData,
        fetched: true,
        fetching: false,
      };
    }

    case FETCH_SECTION_AVAILABILITY_REJECTED:
    case FETCH_SECTION_AVAILABILITY_ABORT:
      return {
        ...state,
        error: action.payload,
        fetched: true,
        fetching: false,
      };

    default:
      return state;
  }
}
